const tokenFormatter = new Intl.NumberFormat('fr-FR', { notation: 'compact', maximumFractionDigits: 1 });

/** Compact token count ("7,7 M", "349 k"); a quantity that is not sent shows "—". */
const formatTokens = (tokens: number | null): string => {
	return tokens === null ? '—' : tokenFormatter.format(tokens);
};

export default formatTokens;
